import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Badge, Drawer, Spin } from 'antd';
import apiUrls from '../../Api/MainApi'
import axios from 'axios'
import Swal from 'sweetalert2'

function CarPolicyListCompany({ setSelectedCheckboxes, selectedCheckboxes, storageChange, setStorageChange }) {
    const [show, setShow] = useState(false);
    const [openPremiumBreakup, setOpenPremiumBreakup] = useState(false);
    const [quotation, setQuotation] = useState({})
    const [idv, setIdv] = useState('')
    const [netPremium, setNetPremium] = useState('')
    const navigate = useNavigate()
    const [gst, setGst] = useState({ cgst: null, igst: null, sgst: null, utgst: null, totalTax: null })
    const [loading, setLoading] = useState(true);


    const handleCheckboxChange = (id) => {    // this function is to  get the particular id of that quoatation to compare
        if (selectedCheckboxes.includes(id)) {
            setSelectedCheckboxes(selectedCheckboxes.filter(item => item !== id));
        } else {
            setSelectedCheckboxes([...selectedCheckboxes, id]);
        }
    };
    // utility function to empty the data when the api hits ,
    function clearData() {
        // console.log("function chala")
        setGst({ cgst: null, igst: null, sgst: null, utgst: null, totalTax: null })
        setNetPremium('')
        setIdv('')

    }

    // Function to fetch the quotation
    const fetchQuotation = async () => {
        try {
            const CarRequest = JSON.parse(sessionStorage.getItem("CarQuotationRequest"));
            if (!CarRequest) {
                Swal.fire({
                    title: "Error",
                    text: "No car request found in session storage.",
                    icon: "error"
                });
                setLoading(false); // Ensure loading is set to false if there's no request
                return;
            }
            clearData() 
            const quotationResponse = await axios.post(apiUrls.PoliciesGen, CarRequest);
            console.log(quotationResponse +" Car Quation"); // Log the entire response for debugging
            if (quotationResponse.status === 200) {
                if (quotationResponse.data.status === 0) {
                    console.log(quotationResponse.data.data, "line 42");
                    console.log(quotationResponse.data.data.vehicle.vehicleIDV.idv, "line 43");
                    const data = quotationResponse.data.data;

                    const idvData = {   // to set the idv data in sessionStorage  to change the idv data accordingly
                        idv: quotationResponse.data.data.vehicle.vehicleIDV.idv ? quotationResponse.data.data.vehicle.vehicleIDV.idv : "",
                        defaultIdv: quotationResponse.data.data.vehicle.vehicleIDV.defaultIdv ? quotationResponse.data.data.vehicle.vehicleIDV.defaultIdv : "",
                        maximumIdv: quotationResponse.data.data.vehicle.vehicleIDV.maximumIdv ? quotationResponse.data.data.vehicle.vehicleIDV.maximumIdv : "",
                        minimumIdv: quotationResponse.data.data.vehicle.vehicleIDV.minimumIdv ? quotationResponse.data.data.vehicle.vehicleIDV.minimumIdv : "",

                    }
                    sessionStorage.setItem('idvDetails', JSON.stringify(idvData))

                    const idv = quotationResponse.data.data.vehicle.vehicleIDV.idv;
                    const premiumString = quotationResponse.data.data.netPremium;
                    const numericPremium = premiumString.replace(/[^0-9.-]+/g, "")
                    const GstObject = quotationResponse.data.data.serviceTax
                    setNetPremium(numericPremium); // Set the numeric premium value in the state
                    setQuotation(data);
                    setGst(prev => ({
                        ...prev,
                        cgst: GstObject.cgst ? GstObject.cgst.replace(/[^0-9.-]+/g, "") : 0,
                        igst: GstObject.igst ? GstObject.igst.replace(/[^0-9.-]+/g, "") : 0,
                        sgst: GstObject.sgst ? GstObject.sgst.replace(/[^0-9.-]+/g, "") : 0,
                        utgst: GstObject.utgst ? GstObject.utgst.replace(/[^0-9.-]+/g, "") : 0,
                        totalTax: Number(GstObject.cgst.replace(/[^0-9.-]+/g, "")) +
                            Number(GstObject.igst.replace(/[^0-9.-]+/g, "")) +
                            Number(GstObject.sgst.replace(/[^0-9.-]+/g, "")) +
                            Number(GstObject.utgst.replace(/[^0-9.-]+/g, ""))
                    }))
                    setIdv(idv);
                } else {

                    Swal.fire({
                        title: "Oops",
                        text: "Data is not fetched",
                        icon: "error"
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // window.location.href = `${process.env.PUBLIC_URL}/`;
                        }
                    });
                }
            } else {
                Swal.fire({
                    title: "Oops",
                    text: "Server is down !!",
                    icon: "error"
                }).then((result) => {
                    if (result.isConfirmed) {
                        // window.location.href = `${process.env.PUBLIC_URL}/`;
                    }
                });
            }
        } catch (error) {
            console.error("Error fetching quotation:", error);
            Swal.fire({
                title: "Error",
                text: "Failed to fetch quotation. Please try again later.",
                icon: "error"
            });
        } finally {
            setLoading(false); // Ensure loading is set to false after the request completes

        }
    };
    function handleNavigate() {  //  to navigate it to next page
        if (netPremium) {
            const quotationResponse = {
                idv: idv,
                netPremium: netPremium,
                totalTax: gst.totalTax,
                image: quotation.ImageData,
                insuranceName: quotation.InsurerName ? quotation.InsurerName : "NA"
            }
            sessionStorage.setItem("quotationResponse", JSON.stringify(quotationResponse))
            navigate(`${process.env.PUBLIC_URL}/motor-insurance/car-policy-details`)
        }
    }
    useEffect(() => {
        fetchQuotation();
        console.log("first")
    }, [])
    useEffect(() => {
        if (storageChange === true) {
            console.log("if")
            setLoading(true)
            fetchQuotation();
            setStorageChange(false)
        }
    }, [storageChange, setStorageChange]);

    const showPremiumBreakup = () => {    // to open the drawer for  premium  breakup 
        setOpenPremiumBreakup(true)
    }
    const onClose = () => {
        setOpenPremiumBreakup(false)
    }
    return (
        <>

            <div className='container policy-list'>
                <h6>Insurance Company</h6>
                {/* ////////////////////// */}
                {
                    loading ? (         // this is the skeleton div for  the loading periods 
                        <div className='quote-display-wrapper'>
                            <div className='info-header-wrapper'>
                                <div className='company-logo-wrapper'>
                                    <Spin size="large" className='ms-2' />
                                </div>
                                <div className='text-wrapper' style={{ width: "100%" }}>
                                    <div className='card__skeleton card__title'></div>
                                    <div className='mt-2 card__skeleton card__title'></div>
                                </div>
                            </div>
                            <div className='header-divider'></div>
                            <div className='features-one-body mt-2'>
                                <span className='features-title'>
                                    AddOns :
                                </span>
                                <div className='ms-2 features-body-wrapper card__skeleton card__title'></div>

                            </div>
                            <div className='features-one-body mt-2'>
                                <span className='features-title'>
                                    Benefits :
                                </span>
                                <div className='ms-2 features-body-wrapper card__skeleton card__title'></div>

                            </div>
                            <div className='features-footer mt-2'>
                                <div className="add-to-compare" style={{ width: "100%" }}>
                                    <div className='card__skeleton card__title'></div>
                                </div>
                                {/* <span >100 Cashless Garage</span> */}
                            </div>
                        </div>
                    ) : (
                        <>
                            <>
                                <Badge.Ribbon placement='start' text="Popular">
                                    <div className='quote-display-wrapper'>
                                        <div className='info-header-wrapper'>
                                            <div className='company-logo-wrapper'>
                                                <img className='company-image' src={quotation.ImageData} alt='logo' />
                                            </div>
                                            <div className="ms-3 show-idv-section ">
                                                <span>
                                                    <label>IDV </label>₹{idv}
                                                </span>
                                            </div>
                                            <div class="buy-now-section">
                                                <span className='share-quotation' onClick={showPremiumBreakup}>View breakup</span>
                                                <button className="buy-now-btn mt-1" onClick={handleNavigate}>
                                                    <span style={{ color: '#fff', fontSize: "15px" }}>₹ {netPremium}</span>
                                                </button>
                                            </div>
                                        </div>
                                        <div className='header-divider'></div>
                                        <div className='features-one-body mt-2'>
                                            <span className='features-title'>
                                                Available :
                                            </span>
                                            <div className='ms-2 features-body-wrapper'>
                                                <span className='features-body'>Zero Depreciation</span>

                                            </div>

                                        </div>
                                        <div className='features-one-body mt-2'>
                                            <span className='features-title'>
                                                Not Available :
                                            </span>
                                            <div className='ms-2 features-body-wrapper '>
                                                <span className='features-body'>On-Ground Support</span>

                                            </div>

                                        </div>
                                        <div className='features-footer mt-2'>
                                            <div className="add-to-compare">
                                                <input type="checkbox" id="addToCompare" onChange={() => handleCheckboxChange(2)} style={{ marginRight: '5px' }} />
                                                <div htmlFor="addToCompare">Add to compare</div>
                                            </div>
                                            {/* <span >100 Cashless Garage</span> */}
                                        </div>
                                    </div>
                                </Badge.Ribbon>
                                <Drawer
                                    title="Your Premium Breakup"
                                    placement='right'
                                    zIndex={3000}
                                    onClose={onClose}
                                    style={{ padding: '15px 0px' }}
                                    visible={openPremiumBreakup}
                                >
                                    <div className='info-div'>
                                        <span>Vehicle value (IDV) : </span>
                                        <span>₹  {idv}</span>
                                    </div>
                                    <div className='info-div'>
                                        <span>NET PREMIUM : </span>
                                        <span>₹  {netPremium}</span>
                                    </div>
                                    <div className='info-div'>
                                        <span>CSGT :</span>
                                        <span>₹  {gst.cgst}</span>
                                    </div>
                                    <div className='info-div'>
                                        <span>IGST :</span>
                                        <span>₹  {gst.igst}</span>
                                    </div><div className='info-div'>
                                        <span>SGST :</span>
                                        <span>₹  {gst.sgst}</span>
                                    </div><div className='info-div'>
                                        <span>UTGST :</span>
                                        <span>₹  {gst.utgst}</span>
                                    </div>
                                    <div className='payment-div'>
                                        <span>Total Premium</span>
                                        <span>₹ {Number(netPremium) + Number(gst.totalTax)}</span>
                                    </div>
                                </Drawer>
                            </>
                        </>
                    )
                }
            </div>
        </>
    )
}

export default CarPolicyListCompany